import React, { useEffect, useState } from "react";
import { X, Hand, Mic, Keyboard, Sparkles } from "lucide-react";

const ROWS = [
  { kind: "kbd", keys: ["Alt", "Tab"], desc: "Cycle to the next open window" },
  { kind: "kbd", keys: ["Alt", "Shift", "Tab"], desc: "Cycle to the previous window" },
  { kind: "kbd", keys: ["⌘", "K"], desc: "Open Spotlight (apps, AI, web)" },
  { kind: "kbd", keys: ["⌘", ","], desc: "Toggle this cheat sheet" },
  { kind: "gesture", icon: Hand, label: "Two-finger swipe ↔︎", desc: "Cycle window focus on the desktop" },
  { kind: "gesture", icon: Hand, label: "Pinch / ⌃ + Wheel", desc: "Zoom feedback on the focused window" },
  { kind: "voice", icon: Mic, label: '"Open Chat"', desc: "Voice command to open any app — works from anywhere" },
  { kind: "voice", icon: Mic, label: '"New task"', desc: "Voice-create a task, note, meeting, or email" },
];

export default function GestureHelp() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onShow = () => setOpen(o => !o);
    window.addEventListener("hexa-gesture-help", onShow);
    return () => window.removeEventListener("hexa-gesture-help", onShow);
  }, []);

  if (!open) return null;
  return (
    <div
      className="fixed inset-0 bg-black/70 flex items-center justify-center z-[900]"
      onClick={() => setOpen(false)}
      data-testid="gesture-help-modal"
    >
      <div
        className="w-[560px] p-5"
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "rgba(14,26,34,0.98)",
          border: "1px solid rgba(139,92,246,0.30)",
          clipPath: "polygon(0 0, calc(100% - 14px) 0, 100% 14px, 100% 100%, 14px 100%, 0 calc(100% - 14px))",
        }}
      >
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <Sparkles size={14} className="text-[#8b5cf6]" />
            <div className="mono text-[11px] uppercase tracking-[0.3em] text-[#8b5cf6]">// voice + gesture cheat sheet</div>
          </div>
          <button onClick={() => setOpen(false)} className="text-white/55 hover:text-white"><X size={14} /></button>
        </div>
        <div className="grid grid-cols-1 gap-2">
          {ROWS.map((r, i) => (
            <div key={i} className="flex items-center gap-3 p-2 border border-white/10">
              <div className="flex items-center gap-1 min-w-[180px]">
                {r.kind === "kbd" ? (
                  <>
                    <Keyboard size={12} className="text-[#c7c1ff]/55" />
                    {r.keys.map((k, ki) => (
                      <React.Fragment key={ki}>
                        <kbd className="mono text-[10px] px-1.5 py-0.5 bg-[#0e1a22] border border-[#8b5cf6]/30 text-[#a78bfa]">{k}</kbd>
                        {ki < r.keys.length - 1 && <span className="text-white/30 mono text-[10px]">+</span>}
                      </React.Fragment>
                    ))}
                  </>
                ) : r.kind === "gesture" ? (
                  <>
                    <r.icon size={12} className="text-[#3b82f6]" />
                    <span className="mono text-[10px] uppercase tracking-[0.2em] text-[#60a5fa]">{r.label}</span>
                  </>
                ) : (
                  <>
                    <r.icon size={12} className="text-[#a78bfa]" />
                    <span className="mono text-[10px] tracking-wide text-[#c4b5fd]">{r.label}</span>
                  </>
                )}
              </div>
              <div className="text-[11px] text-white/70 flex-1">{r.desc}</div>
            </div>
          ))}
        </div>
        <div className="mt-4 text-[10px] mono uppercase tracking-widest text-[#c7c1ff]/45">
          // tip: click the mic in the top bar, then say a command like "open team chat"
        </div>
      </div>
    </div>
  );
}
